<template>
  <div class="app-wrapper" id="app" :class="componentClass" :style="componentStyle">
    <template v-if="topBarType !== TOP_BARS.NULL && !$isMiniProgram">
      <HomeTopBar v-if="topBarType === TOP_BARS.INDEX" />
      <TopBarNoUser v-else-if="topBarType === TOP_BARS.NO_USER" />
      <HomeTopBar skin="inner" v-else-if="topBarType === TOP_BARS.INNER" />
      <TopBarSchool v-else-if="topBarType === TOP_BARS.SCHOOL" />
      <TopBarSl v-else-if="topBarType === TOP_BARS.SL" />
      <TopBarTeacher v-else-if="topBarType === TOP_BARS.TEACHER" />
      <TopBarByRole v-else-if="topBarType === TOP_BARS.BY_ROLE" />
      <TopBarTextBlock v-else-if="topBarType === TOP_BARS.TEXT_BLOCK" />
      <TopBarBack v-else-if="topBarType === TOP_BARS.BACK" />
      <TopBarDefault v-else />
      <!-- do something  -->
      <StuApplyProcessTopBar v-if="topBarProcess === PROCESS.STU_APPLY" />
    </template>
    <router-view />
    <SideHelper />
    <FloatingToolbar class="floating-toolbar" />
    <Cheat v-if="isShowDeveloperView" />
    <template v-if="footerType === FOOTERS.DEFAULT">
      <DefaultFooter />
    </template>
  </div>
</template>
<script>
import TOP_BARS from './utils/topBars';
import FOOTERS from './utils/footers';
import PROCESS from './utils/process';
import SideHelper from 'components/SideHelper';
import FloatingToolbar from 'components/FloatingToolbar';
import './less/common.less';
import Plat from 'utils/plat';
import { setIosSafeArea } from "@/utils/style";
import Login from 'utils/login';
import { ROLES } from 'constants/role';

const TEST_WHITE_LOCATIONS = /innersecurity|blackboard\/poster|poster/i;
const AMC_WHITE_LOCATIONS = /amcsecurity/i;
export default {
  name: 'App',
  components: {
    SideHelper,
    Cheat: () => import('./Cheat'),
    TopBarDefault: () => import('./components/Topbar'),
    TopBarNoUser: () => import('./components/Topbar/TopBar'),
    TopBarSchool: () => import('./components/Topbar/TopBarSchool'),
    TopBarSl: () => import('./components/Topbar/TopBarSL'),
    TopBarTeacher: () => import('./components/Topbar/TopBarTeacher'),
    TopBarByRole: () => import('./components/Topbar/TopBarByRole'),
    HomeTopBar: () => import('./components/Topbar/HomeTopBar'),
    StuApplyProcessTopBar: () => import('./components/Topbar/StuApplyProcessTopBar'),
    TopBarTextBlock: () => import('./components/Topbar/TopBarBlock'),
    TopBarBack: () => import('./components/Topbar/TopBarBack'),
    DefaultFooter: () => import('./components/Footer'),
    FloatingToolbar
  },
  computed: {
    topBarType() {
      const metaBar = this.$route.meta.topBar;
      if (this.$route.name === 'dashboard' && Login.getCurrentLoginRole() === ROLES.TEACHER) {
        return TOP_BARS.TEACHER;
      }
      if (Login.getCurrentLoginRole() === ROLES.SCHOOL && this.$route.name === 'course-detail') {
        return TOP_BARS.SCHOOL;
      }
      return metaBar;
    },
    footerType() {
      return this.$route.meta.footer;
    },
    topBarProcess() {
      return this.$route.meta.process;
    },
    PROCESS() {
      return PROCESS;
    },
    TOP_BARS() {
      return TOP_BARS;
    },
    FOOTERS() {
      return FOOTERS;
    },
    componentClass() {
      let ret = {
        miniprogram: this.$isMiniProgram,
        wechat: this.$isWeiXin
      };
      return ret;
    },
    componentStyle() {
      return {};
    }
  },
  mounted() {
    setIosSafeArea();
    this.setViewHeight();
    this.setSafeBottomArea();
    window.onresize = () => {
      this.setViewHeight();
    };
  },
  beforeUpdate() {
    console.log('beforeUpdate');
    this.bindReferrer();
  },
  async created() {
    this.$volc.sendUserAttributes();
    await this.bindReferrer();
    if (this.isTestSite && !this.isTester && !location.pathname.match(TEST_WHITE_LOCATIONS) && !this.$isMiniProgram) {
      this.$location('/innersecurity');
      return;
    }
    // if (this.$store.state.isAMCSite && !this.isAMCUser && !location.pathname.match(AMC_WHITE_LOCATIONS)) {
    if (this.$store.state.isAMCSite) {
      window.localStorage.setItem('amc-auth', true);
      // this.$location('/amcsecurity');
    }
    this.$store.dispatch('startEB1Countdown');
    this.$store.dispatch('startEB2Countdown');
    this.$store.dispatch('startMrdCountdown');
    this.$store.dispatch('startRdCountdown');
  },
  methods: {
    // 绑定小程序推荐人
    async bindReferrer() {
      const KEY = 'MINI_referrer_id';
      const isLogin = this.$login.isLogin();
      const referrerId = this.$route.query?.mini_referrer_id;
      console.log('this.$route.query', this.$route);
      if (referrerId) {
        localStorage.setItem(KEY, referrerId);
      }
      const localReferrerId = localStorage.getItem(KEY);
      if (isLogin && localReferrerId) {
        // 绑定推荐人id
        const res = await this.$api.post.postStudentTalentHuntBind({ hunter_id: localReferrerId });
        if (res.status === this.$code.SUCCESS && res.data.success) {
          console.log('bindReferrer 绑定推荐人id 绑定成功删除推荐人id');
          localStorage.removeItem(KEY);
        }
      }
    },
    setViewHeight() {
      let topbarHeight = 80;
      // 获取窗口的高度，单位为像素
      let windowVH = window.innerHeight / 100;
      // 设置文档的高度，单位为像素
      document.documentElement.style.setProperty('--vh', windowVH + 'px');
      // 获取窗口的宽度，单位为像素
      let windowVW = window.innerWidth / 100;
      // 设置文档的宽度，单位为像素
      document.documentElement.style.setProperty('--vw', windowVW + 'px');
      if (this.$isMiniProgram) {
        topbarHeight = 0 + 'px';
      } else {
        if (window.innerWidth >= 1188) {
          topbarHeight = 80 + 'px';
        } else {
          topbarHeight = 60 + 'px';
        }
      }
      document.documentElement.style.setProperty('--top-bar-height', topbarHeight);
    },
    setSafeBottomArea() {
      if (Plat.isMiniProgram()) {
        document.documentElement.style.setProperty('--sab', '34px');
      } else {
        document.documentElement.style.setProperty('--sab', 'env(safe-area-inset-bottom)');
      }
    }
  }
};
</script>
